// src/theme.js
import { extendTheme } from "@chakra-ui/react";

const theme = extendTheme({
  colors: {
    brand: {
      success: "#16a34a",
      successDark: "#064e3b",
      successDarker: "#052e16",
      successLight: "#4ade80",
      bgDark: "#064e3b",
      bgDarker: "#052e16",
    },
    // Creating a green color scheme based on your colors
    green: {
      50: "#f0fdf4",
      100: "#dcfce7",
      200: "#4ade80", // your success-light
      300: "#86efac",
      400: "#22c55e",
      500: "#16a34a", // your success
      600: "#15803d",
      700: "#064e3b", // your success-dark
      800: "#052e16", // your success-darker
      900: "#041f11",
    },
  },
  styles: {
    global: (props) => ({
      body: {
        bg: props.colorMode === "dark" ? "brand.bgDarker" : "gray.50",
      },
    }),
  },
  components: {
    Button: {
      defaultProps: {
        colorScheme: "green", // Set default button color to green
      },
    },
  },
});

export default theme;
